import {
  CVStepWorkExperienceSchema,
  CVStepWorkIndustriesSchema
} from 'schemas/cv-steps'
import { z } from 'zod'

const cVStepWorkExperienceValidator = CVStepWorkExperienceSchema
export const cVStepWorkIndustriesValidator = CVStepWorkIndustriesSchema

export type ICVStepWorkExperienceValidator = z.infer<
  typeof cVStepWorkExperienceValidator
>
export default cVStepWorkExperienceValidator
